export const formOrderObjFromCart = (data = null) => {
    const environmentDetails = data?.itemDetail?.catalogService?.catalogConfig?.environmentDetails || null;
    const catalogConfig = data?.itemDetail?.catalogService?.catalogConfig || null;
    const entityDetails = data?.itemDetail?.entityDetails || null;
    return {
        appProfile: catalogConfig?.applicationService || null,
        applicationName: catalogConfig?.applicationName || null,
        appShortName: catalogConfig?.appShortName || null,
        sector: catalogConfig?.sector || environmentDetails?.sector,
        environment: catalogConfig?.environment || null,
        appRegion: catalogConfig?.region || null,
        department: catalogConfig?.department || null,
        // region: environmentDetails?.region || null,
        // regionDisplayName: { label: environmentDetails?.region || null, value: environmentDetails?.region || null },
        hCode: environmentDetails?.costCenter || null,
        ...(environmentDetails?.costCenter && {
            hCodeDetails: { label: environmentDetails?.costCenter, value: environmentDetails?.costCenter },
        }),
        appOwner: `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`,
        appOwnerDetails: {
            label: `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`,
            gpid: entityDetails?.applicationManagerGpid,
            name: entityDetails?.applicationManager,
            email: entityDetails?.applicationManagerEmail,
        },
        awsAccount: catalogConfig?.awsAccountId || null,
        botName: catalogConfig?.botName || null,
        botDescription: catalogConfig?.botDescription || null,
        botPrefix: catalogConfig?.botPrefix || null,
        creationMethod: catalogConfig?.botMethod || null,
        locale: catalogConfig?.locale || null,
        voiceId: catalogConfig?.voiceId || null,
        sessionTimeout: catalogConfig?.timeout || null,
        ischildDirected: catalogConfig?.ischildDirected || null,
        catalogCode: data?.itemDetail?.catalogService?.catalogServiceCode,
        catalogType: data?.itemDetail?.catalogService?.catalogType,
        entityDetails: { ...entityDetails },
        cloudProvider: data?.itemDetail?.catalogService?.cloudProvider,
        cloudService: data?.itemDetail?.catalogService?.cloudService,
        enabledManualBudgetCode: catalogConfig?.enabledManualBudgetCode || true,
        validationStatus: 'clearValidation',
        isTouched: false,
    };
};

export const formOrderObjFromOrderDetails = (catalogServiceId = null, data = null) => {
    const catalog = data?.catalogServices?.find((item) => item?.catalogServiceId === catalogServiceId) || null;
    const catalogConfig = catalog?.catalogConfig || null;
    const environmentDetails = catalogConfig?.environmentDetails || null;
    const entityDetails = data?.entityDetails || null;
    return {
        appProfile: catalogConfig?.applicationService || null,
        applicationName: catalogConfig?.applicationName || null,
        appShortName: catalogConfig?.appShortName || null,
        sector: catalogConfig?.sector || environmentDetails?.sector,
        environment: catalogConfig?.environment || null,
        appRegion: catalogConfig?.region || null,
        department: catalogConfig?.department || null,
        hCode: environmentDetails?.costCenter || null,
        ...(environmentDetails?.costCenter && {
            hCodeDetails: { label: environmentDetails?.costCenter, value: environmentDetails?.costCenter },
        }),
        appOwner: `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`,
        appOwnerDetails: {
            label: `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`,
            gpid: entityDetails?.applicationManagerGpid,
            name: entityDetails?.applicationManager,
            email: entityDetails?.applicationManagerEmail,
        },
        awsAccount: catalogConfig?.awsAccountId || null,
        botName: catalogConfig?.botName || null,
        botDescription: catalogConfig?.botDescription || null,
        botPrefix: catalogConfig?.botPrefix || null,
        creationMethod: catalogConfig?.botMethod || null,
        locale: catalogConfig?.locale || null,
        voiceId: catalogConfig?.voiceId || null,
        sessionTimeout: catalogConfig?.timeout || null,
        ischildDirected: catalogConfig?.ischildDirected || null,
        catalogCode: catalog?.catalogServiceCode,
        catalogType: catalog?.catalogType,
        entityDetails: { ...entityDetails },
        cloudProvider: catalog?.cloudProvider,
        cloudService: catalog?.cloudService,
        enabledManualBudgetCode: catalogConfig?.enabledManualBudgetCode || true,
        validationStatus: 'clearValidation',
        isTouched: false,
    };
};
export const resetOrder = {
    // Application Section
    applicationName: null,
    appShortName: null,
    appProfile: null,
    entityDetails: null,
    sector: null,
    sectorDetails: null,
    department: null,
    appRegion: null,
    environment: null,
    landingZoneDetails: null,
    hCode: null,
    hCodeDetails: null,
    appOwner: null,
    appOwnerDetails: null,

    // Resource Section
    botName: null,
    botDescription: null,
    botPrefix: null,
    creationMethod: 'Create Blank Bot',
    locale: null,
    voiceId: null,
    sessionTimeout: null,
    ischildDirected: null,

    tags: [],
    estimatedCost: {
        details: [],
        qty: null,
        totalOneTimeCost: {
            frequency: 'one time',
            estCost: null,
            currency: 'USD',
        },
        totalRecurringCost: {
            frequency: 'monthly',
            estCost: null,
            currency: 'USD',
        },
        notes: 'Total Est. Cost does not include the DR/backup services cost & any Pepsico internal chargebacks',
    },
    placeNewOrder: new Date(),
    validationStatus: 'clearValidation',
    isTouched: false,
};

export const resetToggleSspModal = {
    isCost: { costType: '', isCostOpen: false },
    isTagOpen: false,
    isApplicationOpen: false,
    isSubmitOrderSuccess: false,
    isUpdatedToCart: false,
    isCostSplitOpen: false,
};

export const resetCostEstimateDetails = {
    details: [],
    qty: null,
    totalOneTimeCost: {
        frequency: 'one time',
        estCost: null,
        currency: 'USD',
    },
    totalRecurringCost: {
        frequency: 'monthly',
        estCost: null,
        currency: 'USD',
    },
    notes: 'Total Est. Cost does not include the DR/backup services cost & any Pepsico internal chargebacks',
};

export const costPayload = ({ order = [], catalogCode, catalogServiceId }) => {
    const payload = {
        ...(catalogServiceId && { catalogServiceId }),
        catalogServiceCode: catalogCode,
        quantity: 1,
        catalogConfig: {
            environmentDetails: {
                region: order?.landingZoneDetails?.region,
            },
            memorySize: order?.memory,
        },
    };
    return payload;
};
